import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { DeviceReset } from '../device-reset.model';

export enum DeviceResetActionTypes {
  LoadDeviceResets = '[DeviceReset] Load DeviceResets',
  AddDeviceReset = '[DeviceReset] Add DeviceReset',
  UpsertDeviceReset = '[DeviceReset] Upsert DeviceReset',
  AddDeviceResets = '[DeviceReset] Add DeviceResets',
  UpsertDeviceResets = '[DeviceReset] Upsert DeviceResets',
  UpdateDeviceReset = '[DeviceReset] Update DeviceReset',
  UpdateDeviceResets = '[DeviceReset] Update DeviceResets',
  DeleteDeviceReset = '[DeviceReset] Delete DeviceReset',
  DeleteDeviceResets = '[DeviceReset] Delete DeviceResets',
  ClearDeviceResets = '[DeviceReset] Clear DeviceResets',
  DeviceResetsFail = '[DeviceReset] DeviceResets Fail',
  GetResetDeviceLog = '[DeviceReset] Get DeviceResets Log',
  GetResetDeviceLogFail = '[DeviceReset] Get DeviceResets Log Fail',
  GetResetDeviceLogSuccess = '[DeviceReset] Get DeviceResets Log Success',
}

export class LoadDeviceResets implements Action {
  readonly type = DeviceResetActionTypes.LoadDeviceResets;

  constructor(public payload: any = null) {}
}

export class AddDeviceReset implements Action {
  readonly type = DeviceResetActionTypes.AddDeviceReset;

  constructor(public payload: { deviceReset: DeviceReset }) {}
}

export class UpsertDeviceReset implements Action {
  readonly type = DeviceResetActionTypes.UpsertDeviceReset;

  constructor(public payload: any = null) {}
}

export class AddDeviceResets implements Action {
  readonly type = DeviceResetActionTypes.AddDeviceResets;

  constructor(public payload: { deviceResets: DeviceReset[] }) {}
}

export class UpsertDeviceResets implements Action {
  readonly type = DeviceResetActionTypes.UpsertDeviceResets;

  constructor(public payload: { deviceResets: DeviceReset[] }) {}
}

export class UpdateDeviceReset implements Action {
  readonly type = DeviceResetActionTypes.UpdateDeviceReset;

  constructor(public payload: { deviceReset: Update<DeviceReset> }) {}
}

export class UpdateDeviceResets implements Action {
  readonly type = DeviceResetActionTypes.UpdateDeviceResets;

  constructor(public payload: { deviceResets: Update<DeviceReset>[] }) {}
}

export class DeleteDeviceReset implements Action {
  readonly type = DeviceResetActionTypes.DeleteDeviceReset;

  constructor(public payload: { id: string }) {}
}

export class DeleteDeviceResets implements Action {
  readonly type = DeviceResetActionTypes.DeleteDeviceResets;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearDeviceResets implements Action {
  readonly type = DeviceResetActionTypes.ClearDeviceResets;
}

export class DeviceResetsFail implements Action {
  readonly type = DeviceResetActionTypes.DeviceResetsFail;
}

export class GetResetDeviceLog implements Action {
  readonly type = DeviceResetActionTypes.GetResetDeviceLog;
}

export class GetResetDeviceLogFail implements Action {
  readonly type = DeviceResetActionTypes.GetResetDeviceLogFail;
}

export class GetResetDeviceLogSuccess implements Action {
  readonly type = DeviceResetActionTypes.GetResetDeviceLogSuccess;

  constructor(public payload: any = null) {}
}

export type DeviceResetActions =
 LoadDeviceResets
 | AddDeviceReset
 | UpsertDeviceReset
 | AddDeviceResets
 | UpsertDeviceResets
 | UpdateDeviceReset
 | UpdateDeviceResets
 | DeleteDeviceReset
 | DeleteDeviceResets
 | ClearDeviceResets
 | DeviceResetsFail
 | GetResetDeviceLog
 | GetResetDeviceLogFail
 | GetResetDeviceLogSuccess;



